import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import {
  ImageSettings,
  RichTextWrapperComponent,
} from '@legacy/common-ui-utility-components';
import { InnogyComponentRendering } from '@core/jss-models';
import type { ButtonTheme } from '@legacy/common-ui-partials';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import {
  ButtonComponent,
  MediaCardComponent,
  ImageComponent,
  StructuredContentComponent,
} from '@legacy/common-ui-partials';
import { NgClass } from '@angular/common';
import { TrackLinkDirective } from '@analytics/events';

import type { BasicContentVariant } from '../../basic-content-settings.model';
import {
  BasicContentValues,
  BasicContentSettings,
} from '../../basic-content-settings.model';
import { ComposableCardConfig } from '../../../composables/card/card.model';

@Component({
  selector: 'wl-basic-content-variant-media-card',
  templateUrl: './basic-content-variant-media-card.component.html',
  styleUrls: ['./basic-content-variant-media-card.component.scss'],
  standalone: true,
  imports: [
    MediaCardComponent,
    ImageComponent,
    StructuredContentComponent,
    FaIconComponent,
    JssModule,
    RichTextWrapperComponent,
    ButtonComponent,
    NgClass,
    TrackLinkDirective,
  ],
})
export class BasicContentVariantMediaCardComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: BasicContentValues;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() settings?: BasicContentSettings;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() image?: ImageSettings;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() cardConfig?: ComposableCardConfig;

  primaryButtonTheme: ButtonTheme = 'secondary';

  public displayImage(variant: BasicContentVariant, image?: ImageSettings) {
    return variant !== 'minimal' && !!image?.image?.src;
  }

  private setPrimaryButtonTheme() {
    const buttonStyleString = this.content?.buttons?.primary?.style;
    const style = buttonStyleString?.includes('primary')
      ? 'primary'
      : 'secondary';
    this.primaryButtonTheme = style;
  }

  ngOnInit() {
    this.setPrimaryButtonTheme();
  }
}
